<!-- Rubrique vignette -->
<div [class.shadowed]="rub.isSelected"
     [ngClass]="cssService.rubricNavButton"
     [ngStyle]="{ background: rub.color }"
     class="flex flex-row items-center text-center gap-2 px-4"
     (click)="onClickrubric(rub)" [matMenuTriggerFor]="rub.childs.length > 0 ? rubMenu : null"
     id="id-{{rub.id}}">

  <!-- Voir Tout -->
  <mat-icon *ngIf="rub.id === 'all'">visibility</mat-icon>

  <!-- Promotions  -->
  <mat-icon *ngIf="rub.id === 'promo'">alarm</mat-icon>

  <!-- Image Rubrique  text-ellipsis max-w-40
  <img *ngIf="rub.image.length > 0" class="w-8 h-auto rounded-full" src="{{ rub.image[2] }}"/>-->

  <div class="flex-1 text-sm text-white overflow-hidden text-ellipsis whitespace-nowrap min-w-[80px] max-w-[200px]">{{ rub.name | uppercase }}</div>

</div>

<!-- Menu sous rubrique -->
<mat-menu #rubMenu="matMenu">
  <button mat-menu-item *ngFor="let sRub of rub.childs" (click)="findRub(sRub)">
    {{ sRub.name | capitalize }}
  </button>
</mat-menu>
